export const StateLabel = ({state}) => {
  if (!state) return null
  if (state === 'activated') return null
  return <span className={`badge badge-${state}`}>{I18n.t(`misc.state_labels.${state}`)}</span>
}
